import { Component, inject } from '@angular/core';
import { RestDayService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RestDayCreateDto,
  RestDayDto,
  RestDayExcelDownloadDto,
  RestDayUpdateDto,
} from '../proxy/general/dtos/rest-day';
import { RESTDAY_CONFIG, RESTDAY_FIELDS } from './rest-day.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-rest-day',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RestDayService, ConfirmationService],
  templateUrl: './rest-day.html',
  styleUrl: './rest-day.scss',
})
export class RestDay extends BaseCrudComponent<
  RestDayDto,
  RestDayCreateDto,
  RestDayUpdateDto,
  RestDayExcelDownloadDto
> {
  service = inject(RestDayService);
  config = RESTDAY_CONFIG;
  fields = RESTDAY_FIELDS;

  protected prepareUpdateDto(data: any, selected: RestDayDto): RestDayUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isRestDay: data.isRestDay,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RestDay';
  }
}
